export { default as DefaultAvatarIllustration } from './DefaultAvatarIllustration'
export { default as EmptyDrawerIllustration } from './EmptyDrawerIllustration'
export { default as EmptyFolderIllustration } from './EmptyFolderIllustration'
export { default as HandshakeIllustration } from './HandshakeIllustration'
export { default as OnlyModulePermissionsIllustration } from './OnlyModulePermissionsIllustration'
export { default as PowerPlugIllustration } from './PowerPlugIllustration'
export { default as WithoutBondOptionIllustration } from './WithoutBondOptionIllustration'
export { default as WithoutCameraIllustration } from './WithoutCameraIllustration'
export { default as WithoutPermissionIllustration } from './WithoutPermissionIllustration'
